




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import { GoogleAuthResponse } from '../User';
import { TokenUser } from '../TokenUser';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';

@Component({
  name: 'GoogleLoginButton',
  components: {}
})
export default class GoogleLoginButtonComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: false })
  public signUpInsteadOfSignIn: boolean;

  // public reactive member variables available to the html template
  public get buttonImage(): string { return this.signUpInsteadOfSignIn ? '/images/btn_google_signup_dark_normal_web@2x.png' : '/images/btn_google_signin_dark_normal_web@2x.png' }

  // public functions available to the html template
  public async onClick() {

    this.$emit('buttonClicked')

    utils_tracker.track('User ClickedLogin Google', {})

    // Gives me the goods here that I can send to my server
    //  Upload id_token to the server and if all is good, get logged in TokenUser from server. Don't send parsed out profile stuff to server because then you could get spoofed.
    //  Then server parses the giant id_token into the profile fields encoded in it.
    //  Actually send the full authResponse to server to save into DB in case we need access_token down the road.
    const googleUser = await this.$gAuth.signIn()
    const basicProfile = googleUser.getBasicProfile()
    const googleAuthResponse: GoogleAuthResponse = googleUser.getAuthResponse()
    if (this.$store.state.devmode) {
      console.log(`googleUser.getId(): ${googleUser.getId()}`)
      console.log(`Id: ${basicProfile.getId()}`)
      console.log(`Full name: ${basicProfile.getName()}`)
      console.log(`First name: ${basicProfile.getGivenName()}`)
      console.log(`Last name: ${basicProfile.getFamilyName()}`)
      console.log(`Image URL: ${basicProfile.getImageUrl()}`)
      console.log(`Email: ${basicProfile.getEmail()}`)
      console.log(`id_token: ${googleAuthResponse.id_token}`)
    }

    // This method gives me an auth code which I'm supposed to upload to server and have server make server-to-server calls to get google auth stuff.
    // Eh, seems simpler to send id_token (JWT) and parse it using google-auth-library on server side. I guess if I wanted to store 
    //  make calls to google using access_token and refresh_token, I would use this method.
    // const authCode = await this.$gAuth.getAuthCode()
    // console.log(`authCode: ${authCode}`)      // e.g. 4/0AY0e-g4u7I4KID3mDHQc9JHvQcli98pXfNH6EwHZphFijN4T_QdFSruHZjY9DUCsg1RAZg

    // When does this happen?
    if (!googleAuthResponse) {
      console.log(`Got null googleAuthResponse`)
      return
    }

    const url: string = utils.getURLprefix() + `/api/auth/gauth`
    try {
      this.$store.commit('setLoading', { loading: true });
      const response: any = await utils.makePostCall(url, { googleAuthResponse });

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // check for success by getting user and session
      if (response.data.user) {
        // success
        this.$emit('close', true)

        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)

        utils.toast(this, 'Success', `You are logged into LiveToken as ${user.email}.`)

        // because segment analytics is loaded in head script
        utils_tracker.alias(user)  // tie the previously anon user to this newly id'd user

        if (this.signUpInsteadOfSignIn) utils_tracker.track('User Registered Google', { email: user.email });
        else utils_tracker.track('User LoggedIn Google', { email: user.email });


        // go to homepage - wrap in try/catch to avoid NavigationDuplicated error
        try { await this.$router.push({ name: 'home' }) } catch (Error) {}

      }

    } catch (error) {
      utils.toast(this, 'Error', 'Could not login using Google')
      if (this.$store.state.devmode) console.log(error);
      return
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template

  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
